/* eslint-disable @next/next/no-img-element */
import React from "react";
import PropTypes from "prop-types";
import { ImageSourcesType } from "./types";

const Image = ({ sources, alt, className }) => (
  <img
    className={className}
    alt={alt}
    src={sources?.["regular@1x"]}
    srcSet={`${sources?.["regular@2x"]} 2x,
            ${sources?.["regular@3x"]} 3x,`}
  />
);

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  sources: ImageSourcesType,
};

Image.defaultProps = {
  alt: "",
  className: "",
  sources: {},
};

export default Image;
